<div class="ui-g-12 elim-bracket">{{ bracket.bracketName }}</div>

<div class="ui-g-12 ui-lg-6">
    <div class="ui-g-12 elim-title text-center" translate>TOURNAMENTS.ELIMINATIONMATCHES</div>
    <div *ngFor="let m of round.matches" class="ui-g-12 text-center">
        <match [match]="m" [round]="round"></match>
    </div>
</div>

<div class="ui-g-12 ui-lg-6">
    <div class="ui-g-12 elim-title text-center" translate>TOURNAMENTS.TEAMSWITHBYES</div>
    <div *ngFor="let team of teamsWithByes" class="ui-g-12 elim-bye text-center">{{ team.name }}</div>
</div>